/**
 * Хелперы «Заявок»: подписи статусов/размеров, форматирование дат,
 * чипы фильтра по статусу.
 */

import dayjs from 'dayjs';

import type {ApplicationStatus, DoctorsRange} from '@services/applications';

export const STATUS_LABEL: Record<ApplicationStatus, string> = {
  pending: 'На рассмотрении',
  reviewed: 'Рассмотрена',
  rejected: 'Отклонена',
};

const DOCTORS_LABEL: Record<DoctorsRange, string> = {
  '2-5': '2–5 врачей',
  '6-10': '6–10 врачей',
  '10+': '10+ врачей',
};

/**
 * Размер клиники словами. Прочерк — это «не спрашивали», и так и
 * должно читаться: у лида с лендинга полей кроме имени и телефона
 * нет. Раньше здесь подставлялось «2–5 врачей», и менеджер видел
 * цифру, которую никто не называл.
 */
export const doctorsLabel = (range: DoctorsRange | null): string =>
  range === null ? '—' : DOCTORS_LABEL[range];

/** Пустое поле в таблице и карточке выглядит одинаково. */
export const orDash = (v: string | null): string => v ?? '—';

export type StatusFilter = ApplicationStatus | 'all';

/** Откуда заявка: из приложения (телефон подтверждён) или с лендинга. */
export type SourceFilter = 'all' | 'verified' | 'lead';

export const SOURCE_CHIPS: {key: SourceFilter; label: string}[] = [
  {key: 'all', label: 'Любые'},
  {key: 'verified', label: 'Из приложения'},
  {key: 'lead', label: 'С лендинга'},
];

/** `phoneVerified` для запроса; undefined — фильтр не наложен. */
export const sourceToVerified = (f: SourceFilter): boolean | undefined =>
  f === 'all' ? undefined : f === 'verified';

export const FILTER_CHIPS: {key: StatusFilter; label: string}[] = [
  {key: 'all', label: 'Все'},
  {key: 'pending', label: 'На рассмотрении'},
  {key: 'reviewed', label: 'Рассмотрены'},
  {key: 'rejected', label: 'Отклонены'},
];

/** «11 авг, 09:42» — подача и рассмотрение. */
export const fmtAppDate = (iso: string): string =>
  dayjs(iso).format('D MMM, HH:mm').replace('.', '');

/** Телефон E.164 → «700 481 200» для моно-колонки (без кода страны). */
export const fmtAppPhone = (phone: string): string => {
  const digits = phone.replace(/\D/g, '').replace(/^996/, '');
  return digits.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
};
